import {AutoProfile} from '@/constants/actionType';

export function setShowPauseToRefillModal(value) {
  return {
    type: AutoProfile.SET_SHOW_PAUSE_TO_REFILL_MODAL,
    value,
  };
}

export function setIsPauseHandled(value) {
  return {
    type: AutoProfile.SET_IS_PAUSE_HANDLED,
    value,
  };
}

export function setRunningMethod(value) {
  return {
    type: AutoProfile.SET_RUNNING_METHOD,
    value,
  };
}
